import { useCallback } from 'react';
import {
  VStack,
  MediaItem,
  Media,
  Hint,
  message,
} from 'app/pages/request-single-page/components-v4';
import { Empty } from '../empty';
import { UploadButton } from '../upload-button';
import { FilesList } from './files-list';

type FilesContentProps = {
  canAdd: boolean;
  committedFilesLength: number;
  draftFiles: MediaItem[];
  onDraftChange: (files: MediaItem[]) => void;
};

export const FilesContent = ({
  canAdd,
  committedFilesLength,
  draftFiles,
  onDraftChange,
}: FilesContentProps) => {
  const remainingSlots = 10 - committedFilesLength;

  const handleSuccess = useCallback((text: string) => {
    message({
      type: 'success',
      text,
    });
  }, []);

  const handleError = useCallback((text: string) => {
    message({
      type: 'error',
      text,
    });
  }, []);

  return (
    <VStack>
      {!!committedFilesLength && <FilesList />}

      {canAdd && (
        <Media.Root initialItems={draftFiles} onItemsChange={onDraftChange}>
          {!!committedFilesLength ? (
            <Hint
              text="Вы уже прикрепили 10 вложений, больше добавить нельзя"
              enabled={!remainingSlots}
              side="bottom"
            >
              <div>
                <UploadButton
                  maxFiles={remainingSlots}
                  style={{ width: '100%' }}
                  onSuccess={handleSuccess}
                  onError={handleError}
                />
              </div>
            </Hint>
          ) : (
            <Empty
              action={
                <UploadButton
                  mode="accent"
                  maxFiles={remainingSlots}
                  isNoFiles
                  onError={handleError}
                />
              }
            />
          )}
        </Media.Root>
      )}
    </VStack>
  );
};
